module.exports = "/_next/static/images/Hero@2x-69c9e9b844a86a6d2cd1d7f4cc11b9e2.webp";